import React from 'react'
import { Route } from 'react-router-dom'

import SurveysIndex from 'pages/AdminSurveys'

const Surveys = () => (
  <React.Fragment>
    <Route path="/:workspaceToken/settings/surveys/" component={SurveysIndex} />
  </React.Fragment>
)

export default Surveys



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/pages/Admin/Surveys/index.js